<template>
	<v-dialog
		:max-width="$isMobile ? '80vw' : '60vw'" 
		v-model="showBanner"
		persistent
	>
		<v-card class="" @click="gotToPayment">
			<v-btn class="close" icon @click.stop="closeDialog">
				<v-icon>mdi-close</v-icon>
			</v-btn>
			<v-img :src="require(`@/assets/dashboard-assets/repayment${$isMobile ? '-mobile' : ''}.png`)" />
		</v-card>
	</v-dialog>
</template>
<script>
import { $productsWithPricePeriods } from '../../Services';
import { mapGetters } from 'vuex'

export default {
	name: 'RepaymentBanner',
	data() {
		return {
			showBanner: false
		}
	},
	computed: {
		...mapGetters({
			studentRegister: 'commons/getStudentActualRegister',
			studentCareer: 'commons/getStudentCareer',
			studentData: 'commons/getStudentData',
		}),
		enableBanner() {
			return this.$isArgentina && [5672, 5759].includes(this.studentCareer?.id)
		},
		isRi() {
			return this.studentData?.careerStatus?.value == 54
		},
	},
	created() {
		this.fetchRepayment()
	},
	methods: {
		async fetchRepayment() {
			if (!this.enableBanner || !this.isRi || !!localStorage.getItem('repayment_banner')) return false

			const { data } = await $productsWithPricePeriods.find(null, null, { params: { studentCareer: this.studentRegister }})
			if (data.products?.length) {
				const arancelIndex = data.products.findIndex(product => product.idProduct == this.$sisConstants('modules.products.arancel'))
				if (arancelIndex >= 0) this.showBanner = true
			}
		},
		gotToPayment() {
			this.$trackEvent('Home', 'Clk_BnrReInscrip_Home', 'Banner_ReInscrip')
			localStorage.setItem('repayment_banner', 1)
			// this.$router.push('/payments')
			window.open('https://forms.office.com/r/zyyEtJE7kZ', '_blank')
			this.showBanner = false
		},
		closeDialog() {
			this.$trackEvent('Home', 'Clk_BnrReInscrip_Close_Home', 'Banner_ReInscrip')
			this.showBanner = false
		},
	}
}
</script>
<style lang="sass" scoped>
	.close
		position: absolute !important
		z-index: 999
		top: 8px
		right: 8px
</style>
